"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATION = exports.SHARE_INVALID_PASSCODE = exports.SHARE_EXPIRED_PRODUCT = exports.SHARE_EXPIRED_LINK = exports.LOGOUT = exports.LOGIN_USER_CLAIMS_NOT_FOUND = exports.GENERAL = exports.CONFIGURATION = exports.AUTH = void 0;
var GENERAL = 2001;
exports.GENERAL = GENERAL;
var AUTH = 2002;
exports.AUTH = AUTH;
var VALIDATION = 2003;
exports.VALIDATION = VALIDATION;
var LOGOUT = 2004;
exports.LOGOUT = LOGOUT;
var SHARE_EXPIRED_PRODUCT = 2005;
exports.SHARE_EXPIRED_PRODUCT = SHARE_EXPIRED_PRODUCT;
var SHARE_EXPIRED_LINK = 2006;
exports.SHARE_EXPIRED_LINK = SHARE_EXPIRED_LINK;
var SHARE_INVALID_PASSCODE = 2007;
exports.SHARE_INVALID_PASSCODE = SHARE_INVALID_PASSCODE;
var CONFIGURATION = 2008;
exports.CONFIGURATION = CONFIGURATION;
var LOGIN_USER_CLAIMS_NOT_FOUND = 2009;
exports.LOGIN_USER_CLAIMS_NOT_FOUND = LOGIN_USER_CLAIMS_NOT_FOUND;